import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import VBadge from "../Icons/VerificationBadge";

// ---------- Styled Components ----------
const Card = styled.div`
  background: #0b0f14;
  border-radius: 16px;
  padding: 1rem;
  color: #e8eef6;
  border: 1px solid #1f2937;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 1rem;

  margin: 1rem 0;

  @media (max-width: 768px) {
    margin: 1rem;
    gap: 0.75rem;
  }
`;

const Header = styled.div`
  background: linear-gradient(135deg, #1f2937, #2b3443);
  border-radius: 12px;
  padding: 3rem;
  text-align: center;
  font-weight: 600;
  position: relative;

  @media (max-width: 768px) {
    padding: 1.5rem;
    font-size: 0.9rem;
  }
`;

const Badge = styled.span`
  position: absolute;
  top: -0.3rem;
  right: 0.75rem;
  background: ${(props) =>
    props.variant === "secondary" ? "#1f2937" : "#1f2937"};
  border: 1px solid #1f2937;
  color: #cbd5e1;
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;

  
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Title = styled.h2`
  font-size: 1rem;
  font-weight: 600;
`;

const Description = styled.p`
  color: #9ca3af;
  font-size: 0.9rem;
`;

const MetaGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  // grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 0.75rem;
`;

const MetaBox = styled.div`
  width: auto;
  border: 1px solid #2b3443;
  border-radius: 50px;
  padding: 0.5rem 0.75rem;
  font-size: 0.7rem;
  color: #9ca3af;
  display: flex;

  span {
    display: block;
    font-weight: 500;
    padding-left: 5px;
  }
`;

const MetaGrid2 = styled.div`
  display: flex;
  gap: 0.75rem;
`;

const MetaBox2 = styled.div`
  width: auto;
  border: 1px solid #2b3443;
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  color: #9ca3af;
  display: flex;
  flex-wrap: wrap;
  items-align: center;
  gap: 5px;

  span {
    font-weight: 500;
    padding-left: 2px;
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 1rem;
`;

const Button = styled.button`
  flex: 1;
  padding: 1rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.7rem;
  cursor: pointer;
  border: none;

  ${(props) =>
    props.primary
      ? `
    background: linear-gradient(135deg, #1f2937, #2b3443);
    color: #00FF00;
    border: 1px solid #374151;
  `
      : `
    background: #111827;
    color: #cbd5e1;
  `}

  &:hover {
    opacity: 0.9;
  }
`;

// ---------- Component ----------
const ClubCard = ({ club }) => {
  // Default values in case club data is missing
  const {
    name = "Unnamed Club",
    description = "No description available",
    img = null,
    chain = "Unknown",
    acceptanceRate = 0,
    floorPrice = "2 ETH",
    totalVolume = 65,
  } = club || {};

  // Helper function to determine club status
  const getClubStatus = () => {
    if (acceptanceRate >= 50) return "Exclusive";
    if (acceptanceRate >= 20) return "Premium";
    return "Open";
  };

  // Helper function to get floorPrice pill color
  const getAcceptanceRateColor = () => {
    if (acceptanceRate >= 70) return "#10b981"; // green → very exclusive
    if (acceptanceRate >= 50) return "#3b82f6"; // blue → premium
    if (acceptanceRate >= 20) return "#f59e0b"; // orange → semi-open
    return "#ef4444"; // red → open to all
  };
  console.log(getAcceptanceRateColor);
  
  const navigate = useNavigate();
  const handleUpload = () => {
    console.log("Selected club for upload:", club);
    navigate('/create-art', { state: { club } });
  }

  return (
    <Card>
      <Header 
        style={{
          backgroundImage: img ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${img})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          color: img ? 'white' : 'inherit',
          textShadow: img ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none',
          minHeight: img ? '120px' : 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: img ? '1.5rem' : '1rem'
        }}
      >
        <span style={{ 
          fontWeight: 'bold',
          fontSize: img ? '1.2rem' : '1rem'
        }}>
          {/* truncate name */}
          {name.length > 20 ? ` (${name.slice(0, 20)}...)` : name}
        </span>
        <Badge style={{
          backgroundColor: img ? 'rgba(255, 255, 255, 0.2)' : undefined,
          backdropFilter: img ? 'blur(10px)' : 'none',
          border: img ? '1px solid rgba(255, 255, 255, 0.3)' : undefined,
          color: img ? 'white' : undefined
        }}>
          {getClubStatus()}
        </Badge>
      </Header>

      <TitleRow>
        <Title>{name}</Title>
        {/* <Pill style={{ backgroundColor: "transparent"}}> */}
          <VBadge />
        {/* </Pill> */}
      </TitleRow>

      <Description>
        {description}
      </Description>

      <MetaGrid>
        <MetaBox>
         Floor Price: <span>{floorPrice}</span>
        </MetaBox>
        <MetaBox>
          Chain: <span>{chain}</span>
        </MetaBox>
        <MetaBox>
          Total Volume: <span>{totalVolume} ETH</span>
        </MetaBox>
        
      </MetaGrid>

      <MetaGrid2>
         <MetaBox2>
           Acceptance Rate : <span style={{ color: getAcceptanceRateColor(acceptanceRate) }}>{acceptanceRate}%</span>
         </MetaBox2>
         {/* <MetaBox2>
           Total: <span>{getClubStatus()}</span>
         </MetaBox2> */}
       </MetaGrid2>

      <Actions>
        <Button onClick={() => console.log(`View details for ${name}`)}>
          About
        </Button>
        <Button
          primary
          onClick={handleUpload}
        >
          Upload →
        </Button>
      </Actions>
    </Card>
  );
};

export default ClubCard;
